// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WKwS7","question":"styles_question__HMVVi","inputVisibleButton":"styles_inputVisibleButton__1drbf","note":"styles_note__3OYDX"};